import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { OpalApiResponseDocument } from '@opallabs/api'

type CustomFieldValue = OpalApiResponseDocument<
  'ExperimentalReadBlockBFFV1',
  200
>['data']['details']['custom_field_values'][number]

export const customFieldValueFactory: Factory<CustomFieldValue> =
  Factory.define<CustomFieldValue>(
    ({ sequence }) =>
      ({
        id: uuidV4(),
        display_name: `Custom Field ${sequence}`,
        type: 'singleSelect',
        association_type: 'direct',
        options: [
          { id: uuidV4(), display_name: 'Option 1', position: 0 },
          { id: uuidV4(), display_name: 'Option 2', position: 1 },
          { id: uuidV4(), display_name: 'Option 3', position: 2 },
        ],
        deactivated_options: [],
        data: {
          id: uuidV4(),
          value: {
            id: uuidV4(),
          },
          notification_mode: 'manual',
          pending_notification_targets: { user_ids: [], group_ids: [] },
        },
      }) satisfies CustomFieldValue
  )
